// Generated at build time by scripts/generate-galleries.mjs.
// Kept in the repository so local type-checking works before the first sync.
export const generatedGalleries: Record<string, string[]> = {};
